import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from 'src/app/shared/shared.module';
import { FbShareModule } from 'src/app/common/fb-share/fb-share.module';
import { WhatsappShareModule } from 'src/app/common/whatsapp-share/whatsapp-share.module';
import { DonateNowModule } from 'src/app/common/donate-now/donate-now.module';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { BasicButtonComponent } from '../basic-button/basic-button.component';
import { SigninSignupComponent } from '../signin-signup/signin-signup.component';

@Component({
  selector: 'app-med-doc-place-holder',
  standalone: true,
  imports: [
    CommonModule,
    BasicButtonComponent,
    MatCardModule,
    SharedModule,
    FbShareModule,
    WhatsappShareModule,
    DonateNowModule,
    SigninSignupComponent
  ],
  templateUrl: './med-doc-place-holder.component.html',
  styleUrls: ['./med-doc-place-holder.component.scss']
})
export class MedDocPlaceHolderComponent implements OnInit {

  @Input() position;
  @Input() sharedCounts;
  @Input() fundraiser;
  @Input() isFundraiserEnded;
  @Input() basicInfo;

  isMobile;
  openLoginPopup = false;

  constructor(
    private events: EventsService,
    public vars: VariablesService,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
  }

  openLogin() {
    this.openLoginPopup = true;
    const ePayload = {
      eventName: 'login_btn_click',
      info_1: this.position
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  signinClosed = () => {
    this.openLoginPopup = false;
  }
}
